import React from "react";
import {css, Theme} from "@emotion/react";

import {Col, Row} from "@pg-design/grid-module";
import {calculateRemSize, flex, mh, mt, ph, pt, pv} from "@pg-design/helpers-css";
import {SelectGroupField} from "@pg-design/select-group";
import {IOption, Select} from "@pg-design/select-module";
import {form, IFormProps} from "@pg-mono/form";

import {ListingChangingButtons} from "../../../search/components/ListingChangingButtons";
import {useAppSelector} from "../../../store/hooks";
import {InvestmentOfferCategory, InvestmentOfferSubCategory, investmentOfferTypes, InvestmentOfferTypeSlug} from "../../constants/investment_offer_constants";
import {IInvestmentOfferListFiltersFields} from "../../hooks/use_investment_offer_filters";
import {getInvestmentOffersSubCategoryOptions} from "../utils/get_investment_offers_subcategory_options";
import {InvestmentOfferSearchDrawer} from "./investmentOfferSearchDrawer";

interface IProps extends IFormProps<IInvestmentOfferListFiltersFields> {
    setInvestmentOffersBlendActive: (state: boolean) => void;
    isMap?: boolean;
    mapUrl?: string;
    listUrl?: string;
    isSticky?: boolean;
}

const CATEGORY_FILTER_NAME = "category";
const SUB_CATEGORY_FILTER_NAME = "subcategory";

export const InvestmentOfferListDesktopFilters = form((props: IProps) => {
    const {isSticky} = props;
    const categorySelectProps = props.getFieldProps(CATEGORY_FILTER_NAME);
    const subCategorySelectProps = props.getFieldProps(SUB_CATEGORY_FILTER_NAME);
    const isAbroad = categorySelectProps.value === InvestmentOfferTypeSlug.ABROAD;

    const categoryOptions = investmentOfferTypes.map((type) => ({value: type.slug, isActive: type.slug === categorySelectProps.value, label: type.namePlural}));
    const subCategoryOptions = getInvestmentOffersSubCategoryOptions(categorySelectProps.value as InvestmentOfferTypeSlug);
    const list = useAppSelector((state) => state.investmentOffer.list.offers);

    const onCategoryChange = (fieldName: string, value: InvestmentOfferCategory) => {
        categorySelectProps.onChange(fieldName, value === categorySelectProps.value ? InvestmentOfferTypeSlug.INVESTMENT : value);
    };

    return (
        <Row css={searchSectionWrapper}>
            <Col lg={16} css={colWrapper}>
                <Col lg={isSticky ? 6 : !isAbroad ? 5 : 5} md={isSticky && !isAbroad ? 6 : isSticky ? 7 : 5} sm={4} css={buttonsColumnWrapper}>
                    <ListingChangingButtons isMap={props.isMap} />
                </Col>
                {!isAbroad && (
                    <Col lg={!isAbroad ? 6 : 5} md={isSticky ? 6 : 4} css={colPadding}>
                        <SelectGroupField {...categorySelectProps} onChange={onCategoryChange} options={categoryOptions} name={CATEGORY_FILTER_NAME} />
                    </Col>
                )}
                <Col
                    lg={isAbroad && isSticky ? 6 : isAbroad && !isSticky ? 8 : 3}
                    md={isAbroad && isSticky ? 5 : isAbroad && !isSticky ? 4 : !isAbroad && !isSticky ? 2 : 3}
                    sm={2}
                    css={colPadding}
                >
                    <Select
                        {...subCategorySelectProps}
                        value={subCategorySelectProps.value ? subCategoryOptions.find(({value}) => value === subCategorySelectProps.value) : ""}
                        options={subCategoryOptions}
                        onChange={(selectedSubCategory) => {
                            let value = "" as InvestmentOfferSubCategory;

                            if (selectedSubCategory) {
                                value = (selectedSubCategory as unknown as IOption).value as InvestmentOfferSubCategory;
                            }

                            subCategorySelectProps.onChange(SUB_CATEGORY_FILTER_NAME, value);
                            subCategorySelectProps.onAfterChange?.(SUB_CATEGORY_FILTER_NAME, value);
                        }}
                        isClearable
                        placeholder="Lokalizacja"
                        instanceId={SUB_CATEGORY_FILTER_NAME}
                        onMenuClose={() => props.setInvestmentOffersBlendActive(false)}
                        onMenuOpen={() => props.setInvestmentOffersBlendActive(true)}
                    />
                </Col>
                {isAbroad && (
                    <Col lg={3} md={isSticky ? 3 : 3} sm={2} css={isSticky ? stickySpacing : pv(0)}>
                        <div css={filtersAndButtonsStyle}>
                            <InvestmentOfferSearchDrawer
                                latestQuery={list.latestQuery}
                                isAbroad={isAbroad}
                                mapUrl={props.mapUrl}
                                listUrl={props.listUrl}
                                isMap={props.isMap}
                            />
                        </div>
                    </Col>
                )}
            </Col>
        </Row>
    );
});

const stickySpacing = (theme: Theme) => css`
    ${mt(0)};
    @media (min-width: ${theme.breakpoints.lg}) {
        ${mt(0)}
    }
`;

const searchSectionWrapper = (theme: Theme) => css`
    @media (min-width: 0px) {
        ${mh("auto")};
        position: relative;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(1)};
    }
`;

const colPadding = (theme: Theme) => css`
    @media (min-width: 0px) {
        ${pt(0)};
        ${ph(0)};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(1)};
        ${ph(2)};
    }
`;

const colWrapper = (theme: Theme) => css`
    @media (min-width: 0px) {
        ${ph(0)};
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
        row-gap: 1.6rem;
    }
    @media (min-width: ${theme.breakpoints.lg}) {
        justify-content: space-between;
        ${pv(0.5)};
    }
`;

const filtersAndButtonsStyle = (theme: Theme) => css`
    ${flex()};
    gap: ${calculateRemSize(2)};
    justify-content: end;

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(1)};
    }
`;

const buttonsColumnWrapper = (theme: Theme) => css`
    @media (min-width: 0px) {
        ${pt(1)};
        ${ph(0)};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(1)};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Col, Row} from "@pg-design/grid-module";
import {calculateRemSize, flex, mh, mt, ph, pt, pv} from "@pg-design/helpers-css";
import {SelectGroupField} from "@pg-design/select-group";
import {IOption, Select} from "@pg-design/select-module";
import {form, IFormProps} from "@pg-mono/form";

import {ListingChangingButtons} from "../../../search/components/ListingChangingButtons";
import {useAppSelector} from "../../../store/hooks";
import {InvestmentOfferCategory, InvestmentOfferSubCategory, investmentOfferTypes, InvestmentOfferTypeSlug} from "../../constants/investment_offer_constants";
import {IInvestmentOfferListFiltersFields} from "../../hooks/use_investment_offer_filters";
import {getInvestmentOffersSubCategoryOptions} from "../utils/get_investment_offers_subcategory_options";
import {InvestmentOfferSearchDrawer} from "./investmentOfferSearchDrawer";

interface IProps extends IFormProps<IInvestmentOfferListFiltersFields> {
    setInvestmentOffersBlendActive: (state: boolean) => void;
    isMap?: boolean;
    mapUrl?: string;
    listUrl?: string;
    isSticky?: boolean;
}

const CATEGORY_FILTER_NAME = "category";
const SUB_CATEGORY_FILTER_NAME = "subcategory";

export const InvestmentOfferListDesktopFilters = form((props: IProps) => {
    const {isSticky} = props;
    const categorySelectProps = props.getFieldProps(CATEGORY_FILTER_NAME);
    const subCategorySelectProps = props.getFieldProps(SUB_CATEGORY_FILTER_NAME);
    const isAbroad = categorySelectProps.value === InvestmentOfferTypeSlug.ABROAD;

    const categoryOptions = investmentOfferTypes.map((type) => ({value: type.slug, isActive: type.slug === categorySelectProps.value, label: type.namePlural}));
    const subCategoryOptions = getInvestmentOffersSubCategoryOptions(categorySelectProps.value as InvestmentOfferTypeSlug);
    const list = useAppSelector((state) => state.investmentOffer.list.offers);

    const onCategoryChange = (fieldName: string, value: InvestmentOfferCategory) => {
        categorySelectProps.onChange(fieldName, value === categorySelectProps.value ? InvestmentOfferTypeSlug.INVESTMENT : value);
    };

    return (
        <Row css={searchSectionWrapper}>
            <Col lg={16} css={colWrapper}>
                <Col lg={isSticky ? 6 : !isAbroad ? 5 : 5} md={isSticky && !isAbroad ? 6 : isSticky ? 7 : 5} sm={4} css={buttonsColumnWrapper}>
                    <ListingChangingButtons isMap={props.isMap} />
                </Col>
                {!isAbroad && (
                    <Col lg={!isAbroad ? 6 : 5} md={isSticky ? 6 : 4} css={colPadding}>
                        <SelectGroupField {...categorySelectProps} onChange={onCategoryChange} options={categoryOptions} name={CATEGORY_FILTER_NAME} />
                    </Col>
                )}
                <Col
                    lg={isAbroad && isSticky ? 6 : isAbroad && !isSticky ? 8 : 3}
                    md={isAbroad && isSticky ? 5 : isAbroad && !isSticky ? 4 : !isAbroad && !isSticky ? 2 : 3}
                    sm={2}
                    css={colPadding}
                >
                    <Select
                        {...subCategorySelectProps}
                        value={subCategorySelectProps.value ? subCategoryOptions.find(({value}) => value === subCategorySelectProps.value) : ""}
                        options={subCategoryOptions}
                        onChange={(selectedSubCategory) => {
                            let value = "" as InvestmentOfferSubCategory;

                            if (selectedSubCategory) {
                                value = (selectedSubCategory as unknown as IOption).value as InvestmentOfferSubCategory;
                            }

                            subCategorySelectProps.onChange(SUB_CATEGORY_FILTER_NAME, value);
                            subCategorySelectProps.onAfterChange?.(SUB_CATEGORY_FILTER_NAME, value);
                        }}
                        isClearable
                        placeholder="Lokalizacja"
                        instanceId={SUB_CATEGORY_FILTER_NAME}
                        onMenuClose={() => props.setInvestmentOffersBlendActive(false)}
                        onMenuOpen={() => props.setInvestmentOffersBlendActive(true)}
                    />
                </Col>
                {isAbroad && (
                    <Col lg={3} md={isSticky ? 3 : 3} sm={2} css={isSticky ? stickySpacing : pv(0)}>
                        <div css={filtersAndButtonsStyle}>
                            <InvestmentOfferSearchDrawer
                                latestQuery={list.latestQuery}
                                isAbroad={isAbroad}
                                mapUrl={props.mapUrl}
                                listUrl={props.listUrl}
                                isMap={props.isMap}
                            />
                        </div>
                    </Col>
                )}
            </Col>
        </Row>
    );
});

const stickySpacing = (theme: Theme) => css`
    ${mt(0)};
    @media (min-width: ${theme.breakpoints.lg}) {
        ${mt(0)}
    }
`;

const searchSectionWrapper = (theme: Theme) => css`
    @media (min-width: 0px) {
        ${mh("auto")};
        position: relative;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(1)};
    }
`;

const colPadding = (theme: Theme) => css`
    @media (min-width: 0px) {
        ${pt(0)};
        ${ph(0)};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(1)};
        ${ph(2)};
    }
`;

const colWrapper = (theme: Theme) => css`
    @media (min-width: 0px) {
        ${ph(0)};
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
        row-gap: 1.6rem;
    }
    @media (min-width: ${theme.breakpoints.lg}) {
        justify-content: space-between;
        ${pv(0.5)};
    }
`;

const filtersAndButtonsStyle = (theme: Theme) => css`
    ${flex()};
    gap: ${calculateRemSize(2)};
    justify-content: end;

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(1)};
    }
`;

const buttonsColumnWrapper = (theme: Theme) => css`
    @media (min-width: 0px) {
        ${pt(1)};
        ${ph(0)};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(1)};
    }
`;
